
import React from "react";
import { Card } from "@/components/ui/card";
import { CurrentLogo } from "./CurrentLogo";
import { LogoUploader } from "./LogoUploader";
import { LogoGrid } from "./LogoGrid";
import { useLogoManagement } from "@/hooks/useLogoManagement";

interface LogoControlProps {
  kitId: string;
}

export const LogoControl: React.FC<LogoControlProps> = ({ kitId }) => {
  const {
    logos,
    isLoadingLogos,
    kitLogo,
    isLoadingKitLogo,
    isUploading,
    handleFileUpload,
    setKitLogo,
    removeKitLogo
  } = useLogoManagement(kitId);

  if (isLoadingLogos) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="h-6 w-6 animate-spin text-white/70 border-t-2 border-white/70 rounded-full" />
      </div>
    );
  }

  return (
    <Card className="p-4 bg-black/20 border-white/10">
      <div className="space-y-4">
        <div className="text-sm text-white/70 mb-2">Current Logo</div>
        <CurrentLogo 
          isLoading={isLoadingKitLogo} 
          kitLogo={kitLogo} 
          onRemove={removeKitLogo}
        />
        
        <LogoUploader 
          isUploading={isUploading} 
          onFileUpload={handleFileUpload}
        />
        
        <LogoGrid 
          logos={logos || []} 
          activeLogoId={kitLogo?.logo_id} 
          onSelectLogo={setKitLogo}
        />
      </div>
    </Card>
  );
};
